
export enum AuctionBetsDisplayType {
    "NONE" = "NONE",
    "ALL" = "ALL",
    "LEADING" = "LEADING"
}
